import apiClient from './apiClient';

export const subscribeNewsletter = async (email) => {
  const response = await apiClient.post('/newsletter/subscribe', {
    email,
    source: 'footer',
  });
  return response.data;
};
